import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {LawAgentsRow} from "../types";

export interface LawAgentsState {
  listLoading: boolean;
  actionsLoading: boolean;
  totalCount: number;
  pageCount: number;
  totalPaid: number;
  entities: LawAgentsRow[] | null;
  error: string | null;
}

export interface Payload {
  totalCount: number;
  pageCount: number;
  totalPaid: number;
  entities: LawAgentsRow[];
}

export const callTypes = {
  list: "list",
  action: "action",
} as const;


const initialLawAgentsState: LawAgentsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  pageCount: 0,
  totalPaid: 0,
  entities: null,
  error: null,
};

export const lawAgentsSlice = createSlice({
  name: "lawAgents",
  initialState: initialLawAgentsState,
  reducers: {
    lawAgentsFetched: (
      state,
      action: PayloadAction<Payload>
    ) => {
      const { totalCount, pageCount, entities, totalPaid } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
      state.totalPaid = totalPaid;
    },
    lawAgentsAppended: (
      state,
      action: PayloadAction<Payload>
    ) => {
      const { totalCount, pageCount, entities, totalPaid } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities
        ? [...state.entities, ...entities]
        : [...entities];
      state.totalCount = totalCount;
      state.pageCount = pageCount;
      state.totalPaid = totalPaid;
    },
    catchError: (
      state,
      action: PayloadAction<{ error: string; callType: typeof callTypes.list | typeof callTypes.action }>
    ) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (
      state,
      action: PayloadAction<{ callType: typeof callTypes.list | typeof callTypes.action }>
    ) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  },
});

export const { lawAgentsFetched, lawAgentsAppended, catchError, startCall } = lawAgentsSlice.actions;